export default __webpack_public_path__ + "static/media/linkedin_icon.f119887a.webp";